import React from 'react'
import Container from './components/Container'

const App = () => {


  return (
    <div className="container-fluid">
      <Container />
    </div>
  )
}

export default App
